module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "form",
    staticClass: "box-set",
    attrs: {
      "model": _vm.form,
      "label-width": "120px"
    }
  }, [_c('el-card', {
    attrs: {
      "header": "基础信息",
      "shadow": "naver"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "活动名称",
      "prop": "title"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 80,
      "placeholder": "活动名称"
    },
    model: {
      value: (_vm.form.title),
      callback: function($$v) {
        _vm.$set(_vm.form, "title", $$v)
      },
      expression: "form.title"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "活动时间"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetimerange",
      "range-separator": "至",
      "start-placeholder": "生效时间",
      "end-placeholder": "过期时间",
      "value-format": "yyyy-MM-dd HH:mm:ss",
      "default-time": ['00:00:00', '23:59:59']
    },
    model: {
      value: (_vm.activity_date),
      callback: function($$v) {
        _vm.activity_date = $$v
      },
      expression: "activity_date"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "赠品说明",
      "prop": "title"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 255,
      "placeholder": "数量有限，先到先得"
    },
    model: {
      value: (_vm.form.free_desc),
      callback: function($$v) {
        _vm.$set(_vm.form, "free_desc", $$v)
      },
      expression: "form.free_desc"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-card', {
    attrs: {
      "header": "绑定主商品",
      "shadow": "naver"
    }
  }, [_c('SkuSelector', {
    attrs: {
      "data": _vm.mainItems
    },
    on: {
      "change": _vm.getMainItems
    }
  })], 1), _vm._v(" "), _c('el-card', {
    attrs: {
      "header": "选择赠品",
      "shadow": "naver"
    }
  }, [_c('SkuSelector', {
    attrs: {
      "data": _vm.relItems
    },
    on: {
      "change": _vm.getItems
    }
  })], 1), _vm._v(" "), _c('el-card', {
    attrs: {
      "header": "赠品设置",
      "shadow": "naver"
    }
  }, [(_vm.form.rel_rules_items.length > 0) ? _c('el-table', {
    staticStyle: {
      "line-height": "normal"
    },
    attrs: {
      "data": _vm.form.rel_rules_items
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "ID",
      "prop": "item_id",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "商品编号",
      "prop": "item_bn",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "名称",
      "prop": "item_title"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "类型",
      "prop": "special_type"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.special_type == 'drug') ? _c('span', {
          staticStyle: {
            "color": "red"
          }
        }, [_vm._v("处方药")]) : _c('span', {
          staticStyle: {
            "color": "blue"
          }
        }, [_vm._v("非处方药")])]
      }
    }], null, false, 2651025645)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "赠品加价",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "size": "mini"
          },
          model: {
            value: (scope.row.activity_price),
            callback: function($$v) {
              _vm.$set(scope.row, "activity_price", $$v)
            },
            expression: "scope.row.activity_price"
          }
        }, [_c('i', {
          staticClass: "el-input__icon",
          attrs: {
            "slot": "prefix"
          },
          slot: "prefix"
        }, [_vm._v(_vm._s(_vm.cursymbol))])])]
      }
    }], null, false, 886840778)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "主商品量",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "size": "mini"
          },
          model: {
            value: (scope.row.main_item_num),
            callback: function($$v) {
              _vm.$set(scope.row, "main_item_num", $$v)
            },
            expression: "scope.row.main_item_num"
          }
        })]
      }
    }], null, false, 3702443501)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "送量",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "size": "mini"
          },
          model: {
            value: (scope.row.rel_item_num),
            callback: function($$v) {
              _vm.$set(scope.row, "rel_item_num", $$v)
            },
            expression: "scope.row.rel_item_num"
          }
        })]
      }
    }], null, false, 2067797469)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('i', {
          staticClass: "iconfont icon-trash-alt",
          on: {
            "click": function($event) {
              return _vm.deleteItemRow(scope.$index, _vm.form.rel_rules_items)
            }
          }
        }), _vm._v(" "), _c('i', {
          staticClass: "iconfont el-icon-plus",
          on: {
            "click": function($event) {
              return _vm.copyeItemRow(scope.$index, _vm.form.rel_rules_items)
            }
          }
        })]
      }
    }], null, false, 2185673631)
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('el-card', {
    attrs: {
      "header": "店铺",
      "shadow": "naver"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "适用店铺"
    }
  }, [_c('el-radio-group', {
    on: {
      "change": _vm.shopTypeChange
    },
    model: {
      value: (_vm.form.use_all_shops_flag),
      callback: function($$v) {
        _vm.$set(_vm.form, "use_all_shops_flag", $$v)
      },
      expression: "form.use_all_shops_flag"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "true"
    }
  }, [_vm._v("全部适用")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "false"
    }
  }, [_vm._v("指定店铺适用")])], 1)], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addDistributorAction
    }
  }, [_vm._v("选择店铺")]), _vm._v(" "), (_vm.distributor_info.length > 0) ? _c('el-table', {
    staticStyle: {
      "line-height": "normal"
    },
    attrs: {
      "data": _vm.distributor_info
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "ID",
      "prop": "distributor_id",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "名称",
      "prop": "name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "address",
      "label": "地址",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('i', {
          staticClass: "iconfont icon-trash-alt",
          on: {
            "click": function($event) {
              return _vm.deleteDistritutorRow(scope.$index, _vm.form.items)
            }
          }
        })]
      }
    }], null, false, 3521329561)
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "content-center"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.handleCancel.apply(null, arguments)
      }
    }
  }, [_vm._v("返回")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitActivityAction()
      }
    }
  }, [_vm._v("保存")])], 1), _vm._v(" "), _c('StoreSelect', {
    attrs: {
      "store-visible": _vm.storeVisible,
      "is-valid": true,
      "rel-shop-ids": _vm.relShopIds,
      "get-status": _vm.setStatus
    },
    on: {
      "chooseStore": _vm.chooseStoreAction,
      "closeStoreDialog": _vm.closeStoreDialogAction
    }
  }), _vm._v(" "), _c('DistributorSelect', {
    attrs: {
      "store-visible": _vm.distributorVisible,
      "is-valid": true,
      "rel-shop-ids": _vm.relDistributorIds,
      "get-status": _vm.setDistributorStatus
    },
    on: {
      "chooseStore": _vm.chooseDistributorAction,
      "closeStoreDialog": _vm.closeDistributorDialogAction
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5a7c0bb1", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a7c0bb1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/member/promotions/buyonesfreeones/add.vue
// module id = 2745
// module chunks = 0